<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-5">
            <div class="col-md-6 m-auto mt-5">
                <div class="card">
                    <div class="card-header small text-white p-1" :style="{ backgroundColor: moduloAtual().color }">
                        Consultar Chave Nota
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1">

                      <div class="small p-0 m-0">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite a chave da nota fiscal"
                            titleScan="Escanear Nota Fiscal"
                            typeInputMode="numeric"
                            @displayScanFunction="consultarChaveNota"
                            :enterKey="(e) => consultarChaveNota(e.target.value, 1)"
                            idInput="codigoBarrasInput"
                            :errorMessage="this.error"
                        >
                        </InputDefaultApp>
                      </div>
                    </div>
                </div>

                <div class="mt-5 mb-5 text-center text-secondary" v-if="!this.retorno">
                  <em class="fa fa-info-circle fa-3x mb-2"></em>
                  <br>
                  <span class="small">Bipe a chave da nota fiscal!</span>
                </div>
            </div>

            <div class="container-fluid m-0 mt-2" v-if="this.retorno">
              <div class="col-md-6 m-auto mt-1 mb-5 p-lg-2 p-md-2 p-0">
                <div class="alert alert-success text-left pt-1 pb-1 pl-2 pr-2 m-0">
                  <span class="small" id="spanRetorno">
                    <ul class="m-0 p-2">
                      <li class="mb-2 ml-1 mr-1" v-for="(item) of this.retorno" :key="item.index">
                        {{ item.message }}
                      </li>
                    </ul>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-6 btn-group w-100 mt-1" v-if="this.chaveNotaReferencia && !this.error">
              <router-link class="btn btn-success btn-sm btn-block" :to="'/primeiraconferencia?chave='+this.chaveNotaReferencia">
                Primeira Conferência
                <em class="fa fa-barcode ml-2"></em>
              </router-link>
            </div>
        </div>

        <LogoutModal />

        <Modal
            id="informarQuantidadeModal"
            title="Quantidade de Pallets"
            :confirmFunction="() => consultar()"
            :carregando="carregando"
        >
            <div class="small">
                <input
                id="quantidade"
                inputmode="numeric"
                class="form-control form-control-sm"
                value="1"
                min="1"
                @keypress.enter="consultar">
            </div>
        </Modal>
        <FooterBar />
    </div>
</template>
  
<script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import Modal from "../components/Modal.vue";
  import InputDefaultApp from '../components/InputDefaultApp.vue';
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUserId, getUsername, getPerfil } from '../services/api'
  import $ from "jquery";
  import audioService from '@/services/audioService.js';

  export default {
    name: 'Categoria',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      Modal,
      InputDefaultApp
    },
  
    data: () => {
      return {
        menus : [],
        categoriaId: null,
        chaveNotaReferencia: null,
        retorno: null,
        error: null,
      };
    },
  
    async mounted() {

      try {
        await this.validarToken();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }

      setTimeout(() => {
        document.getElementById('codigoBarrasInput').focus();
      }, 1000);


      document.getElementById('codigoBarrasInput').addEventListener('focus', function() {
        document.getElementById('codigoBarrasInput').select();
      });
    },
  
    methods: {
      getUsername,
      getPerfil,

      playSound() {
        audioService.ops();
      },
      
      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },

      async consultarChaveNota(value) {
        if (value.trim() !== "" && value.trim().length == 44) {
          this.carregando = true;
          this.chaveNotaReferencia = value;
          try {
            let response =await api.post(`/inbound/buscarchavenota`, {
              chave: value,
              idUsuario: getUserId()
            });

            if (response.status == 200) {

              if (JSON.stringify(response).includes("messageSucces")) { 
                this.chaveNotaReferencia = null;

                this.retorno = [
                  {
                    index: 0,
                    message:response.data.messageSucces
                  }
                ];
                this.error = null;
              } else {
                this.buscarChaveNota(value);
                this.error = null;
              }
             
            }
          } catch(e) {
            this.playSound();
            this.error = e.message;
            this.retorno = null;

            let codigoBarrasInput = document.getElementById('codigoBarrasInput');

            setTimeout(() => {
              codigoBarrasInput.focus();
              codigoBarrasInput.select();
            }, 250);
          }

          this.carregando = false;

        } else {
          this.playSound();
          this.error = "A chave da nota precisa ter 44 caracteres!";
          let codigoBarrasInput = document.getElementById('codigoBarrasInput');
          codigoBarrasInput.value = "";
          setTimeout(() => {
            codigoBarrasInput.focus();
            codigoBarrasInput.select();
          }, 250);
        }
      },

      buscarChaveNota(value) {
        this.retorno = null;
        this.erro = null;

        if (value.trim() !== "" && value.trim().length == 44) {
            this.chaveNotaReferencia = value;
            $("#informarQuantidadeModal").modal("show");
            setTimeout(() => {
              document.getElementById('quantidade').select();
              document.getElementById('quantidade').focus();
            }, 500);
        } else {
          this.error = "A chave da nota precisa ter 44 caracteres!";
          let codigoBarrasInput = document.getElementById('codigoBarrasInput');
          codigoBarrasInput.value = "";
          setTimeout(() => {
            codigoBarrasInput.focus();
            codigoBarrasInput.select();
          }, 250);
          this.playSound();
        }
      },

      async consultar() {
        let quantidade = document.getElementById('quantidade').value;

        if (quantidade < 1) {
          document.getElementById('quantidade').style.border = "1px solid red";
          $("#informarQuantidadeModal").modal("show");
          setTimeout(() => {
            document.getElementById('quantidade').select();
            document.getElementById('quantidade').focus();
          }, 500);
          return;
        }

        document.getElementById('quantidade').style.border = "#CCC";
        let codigoBarrasInput = document.getElementById('codigoBarrasInput');

        this.carregando = true;
        try {
            let response =await api.post(`/inbound/consultarchavenota`, {
              qtdePallets: quantidade,
              idUsuario: getUserId(),
              chave: this.chaveNotaReferencia
            });

            if (response.status == 200) {
                
                if (JSON.stringify(response.data).includes('error')) {
                  this.error = response.data.error;
                  this.playSound();
                  this.carregando = false;
                  $("#informarQuantidadeModal").modal("hide");

                  setTimeout(() => {
                    codigoBarrasInput.focus();
                    codigoBarrasInput.select();
                  }, 1000);

                  return;
                }

                let retorno = response.data.sucesso
                let explode = retorno.split("--||--");

                let mensagens = [];
                let i = 0;
                for (const msg of explode) {

                  if (msg.trim() !== ""){
                      mensagens.push({
                      index: i,
                      message: msg
                    });

                    i++;
                  }
                }
                this.retorno = mensagens;
                this.error = null;
            }
        } catch(e) {
            this.error = e.message;
            this.retorno = null;
            this.playSound();
            $('#codigoBarrasInput').focus();
            codigoBarrasInput.select();
        }
        
        codigoBarrasInput.value = "";

        document.getElementById('quantidade').value = 1;
        $("#informarQuantidadeModal").modal("hide");

        setTimeout(() => {
          codigoBarrasInput.focus();
          codigoBarrasInput.select();
        }, 1000);
        this.carregando = false;
      },
    }
  }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }

    .h-85 {
      height: 85%;
    }
  
    .input-container input {
        width: 80%;
    }
  </style>
  